import { es as plurals } from 'make-plural/plurals'

import { messages } from './messages'

export { messages }
export const localeData = { plurals: plurals }

export const es = { localeData, messages }
